// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1itYw","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__xdZtW"};